import { entityMappingApi, type EntityMappingApi } from '../api/EntityMappingApi'
import type {
  EntityMappingDescriptor,
  EntityMappingDraft,
  SaveEntityMappingOutcome,
} from '../models/entityMapping.types'
import { buildEntityMappingPayload, validateEntityMappingDraft } from '../service/entityMapping'

export class SaveEntityMappingFlow {
  constructor(private readonly api: EntityMappingApi = entityMappingApi) {}

  async save(
    descriptor: EntityMappingDescriptor,
    draft: EntityMappingDraft,
    workspaceId: number | string,
  ): Promise<SaveEntityMappingOutcome> {
    const entityIds = validateEntityMappingDraft(descriptor, draft)
    if (entityIds.length) return { kind: 'incomplete', entityIds }
    const payload = buildEntityMappingPayload(descriptor, draft)
    if (!payload.mappings.length) return { kind: 'empty' }
    await this.api.save(descriptor.path(workspaceId), payload)
    return { kind: 'saved', savedCount: payload.mappings.length }
  }
}
